module.exports = __webpack_public_path__ + "img/9.393bd2e6.jpg";